(() => {
  if (window.gpCartShippingCleanup) return;
  window.gpCartShippingCleanup = true;
  const root = window.Shopify?.routes?.root || '/';
  const keys = ['Envío elegido', 'Sucursal de retiro', 'Confirmación de envío'];
  fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
    .then(response => { if (!response.ok) throw new Error(); return response.json(); })
    .then(cart => {
      const attributes = Object.fromEntries(keys.filter(key => cart.attributes?.[key]).map(key => [key, '']));
      if (!Object.keys(attributes).length) return;
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes })
      });
    })
    .catch(() => {});
})();

